<template>
  <div id="result-list"
    class="result-list"
    :class="layout">
    <div class="result__header">
      <el-pagination
        @size-change="setItemsPerPage"
        @current-change="setPage"
        :current-page="parseInt(page, 10)"
        :page-size="parseInt(itemsPerPage, 10)"
        :page-sizes="[50, 100, 200]"
        layout="total, sizes, prev, pager, next"
        :total="total" />

        <el-button
          @click="exportCSV"
          size="small"
          v-loading="exporting"
        >
          {{$t('pages.results.exportCsv')}}
        </el-button>
    </div>
    <table-exhibition
      v-if="type === 'exhibition'"
      v-loading="loading"
      :results="results"
      :setOrderColumn="setOrderColumn" />
    <table-exhibitor
      v-if="type === 'exhibitor'"
      v-loading="loading"
      :results="results"
      :setOrderColumn="setOrderColumn" />
    <table-exhibited-work
      v-if="type === 'exhibited_work'"
      v-loading="loading"
      :results="results"
      :setOrderColumn="setOrderColumn" />
  </div>
</template>

<script>
import TableExhibition from '../Tables/TableExhibition'
import TableExhibitor from '../Tables/TableExhibitor'
import TableExhibitedWork from '../Tables/TableExhibitedWork'
import { ROUTE_RESULT } from '@/router'
import {
  Pagination,
  Button
} from 'element-ui'
import {
  OPEN_CATALOG_DIALOG,
  GET_CATALOG
} from '@/store/dialog/actions'
import { exportCSV } from '@/services/export'

export default {
  name: 'result-list',
  props: ['layout', 'results', 'type', 'page', 'itemsPerPage', 'total', 'loading'],
  data: function () {
    return {
      exporting: false
    }
  },
  components: {
    TableExhibition,
    TableExhibitor,
    TableExhibitedWork,
    elPagination: Pagination,
    elButton: Button
  },
  methods: {
    openCatalogDialog (obj, id) {
      this.$store.dispatch('dialog/' + OPEN_CATALOG_DIALOG)
      this.$store.dispatch('dialog/' + GET_CATALOG, {
        id
      })
    },
    setPage (page) {
      this.$router.push({
        name: ROUTE_RESULT,
        query: {
          ...this.$route.query,
          page: page
        }
      })
    },
    setItemsPerPage (count) {
      this.$router.push({
        name: ROUTE_RESULT,
        query: {
          ...this.$route.query,
          itemsPerPage: count
        }
      })
    },
    setOrderColumn (order) {
      this.$router.push({
        name: ROUTE_RESULT,
        query: {
          ...this.$route.query,
          order: order.prop,
          direction: order.order === 'ascending' ? 'ASC' : 'DESC'
        }
      })
    },
    async exportCSV () {
      this.exporting = true
      await exportCSV(this.$props.type, this.$route.query)
      this.exporting = false
    }
  }
}
</script>

<style>
.result__header {
  padding: 12px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1em;
}

.result__header .el-pagination {
  flex: 1
}

.result-list {
  /*padding: 20px;*/
  overflow: hidden;
  position: relative;
  z-index: 1;
  background: white;
}
.result-list.hide {
  right: 100%;
  overflow: hidden;
}
.result-list a {
  color: #35C1D6;
}
.result-table .el-table {
  display: flex;
  height: 100%;
  flex-direction: column;
  font-size: 12px;
  padding-bottom: 56px;
}
.result-table {
  width: 100%;
  height: 100%;
}
.el-table__body-wrapper {
  flex: 1;
  overflow: auto;
}
.el-table .el-table__body-wrapper .cell {
  padding: .75em 1em;
  line-height: 1.4;
  word-break: normal;
}

.el-table .el-table__header .cell {
  white-space: nowrap;
}

.result-list.column-100 {
  right: 0;
}

.result-list .el-table tr {
  position: relative;
  overflow: hidden;
  clear: both;
  height: auto;
}

@media (min-width: 992px) {
  .result-list {
    position: fixed;
    z-index: 1;
    background: white;
    bottom: 0;
    top: 127px;
    left: 0;
    right: 35%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, .12), 0px 0px 6px 0px rgba(0, 0, 0, .04);
  }
}

@media (min-width: 1400px) {
  .result-list {
    right: 50%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Result/ResultList/ResultList.vue